import script from "./SitemapView.vue?vue&type=script&setup=true&lang=js"
export * from "./SitemapView.vue?vue&type=script&setup=true&lang=js"

import "./SitemapView.vue?vue&type=style&index=0&id=58ee31ce&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58ee31ce"]])

export default __exports__